<template>
  <v-card classs="overflow-hidden">
    <v-app-bar
      absolute
      color="white"
      elevate-on-scroll
      dense
      scroll-target="#scrolling-techniques-7"
    >
      <v-btn plain onclick="location.href='/smc/'"
        >체감형 가상과학관 기반기술</v-btn
      >
      <v-spacer />
      <span plain class="font-weight-bold">SketchScope</span>
      <v-divider class="mx-3" vertical></v-divider>
      <v-btn plain onclick="location.href='/smc/sketchscope'">Basic</v-btn>
      <v-divider vertical inset opacity="100%"></v-divider>
      <v-btn plain onclick="location.href='/smc/motion_recognition'"
        >Motion Recognition</v-btn
      >
      <v-divider vertical inset />
      <v-btn plain onclick="location.href='/smc/ar'">Augmented Reality</v-btn>
      <v-divider vertical />
      <v-btn
        plain
        class="font-weight-bold"
        onclick="location.href='/smc/others'"
        >Haptics</v-btn
      >
      <v-divider vertical />
      <v-btn
        plain
        class="font-weight-bold"
        onclick="location.href='/smc/ammonite'"
        >Ammonite</v-btn
      >
      <v-divider vertical inset />
      <v-btn plain onclick="location.href='https://cgv.kaist.ac.kr'">
        <img src="@/assets/cgv.png" style="height: 15px; width: 30px" />
      </v-btn>
      <!--      TODO: modify this to real CGV ICONs-->
      <v-btn plain onclick="location.href='http://www.krnamu.or.kr/'"
        >Museum</v-btn
      >
    </v-app-bar>
    <v-sheet id="scrolling-techniques-7">
      <v-container fluid>
        <core-view />
      </v-container>
    </v-sheet>
  </v-card>
</template>

<script>
export default {
  name: "AppView",
  components: {
    CoreView: () => import("@/components/core/View"),
  },
  props: {},
};
</script>

<style scoped></style>
